import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View, StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { TextBody, TextTitle } from '../../atoms';
export const ModalHeader = ({ title, subtitle }) => {
    /**
     * DOM
     */
    return (_jsxs(View, { style: $.container, children: [_jsx(TextTitle, { color: "primary", em: true, small: true, children: title }), subtitle ? (_jsx(TextBody, { center: true, color: "secondary", mt: "2", children: subtitle })) : null] }));
};
const $ = StyleSheet.create({
    container: {
        marginBottom: theme.spacing['8'],
        justifyContent: 'center',
        alignItems: 'center',
    },
});
